var React = require('react');

function Factor (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"factor"},[React.createElement("circle",{"id":"Oval","fill":"#D6A444","cx":"8","cy":"8","r":"8","key":0}),React.createElement("polyline",{"id":"Path-3","stroke":"#FFFFFF","strokeLinecap":"round","points":"4 8.48100037 7.18717523 10.7816495 11.3426364 6","key":1})])));
}

Factor.defaultProps = {"viewBox":"0 0 16 16","version":"1.1"};

module.exports = Factor;

Factor.default = Factor;
